module.exports = __webpack_public_path__ + "img/top3.47f739a3.gif";